module.exports = __webpack_public_path__ + "static/hero-53052ca959f7b0f3576831ae665730de.jpg";